<style lang="less">
@import './main.less';
</style>
<template>
  <div class="main" :class="{ 'main-hide-text': shrink }">
    <div class="sidebar-menu-con" :style="{ width: shrink ? '80px' : '256px', overflow: shrink ? 'visible' : 'auto' }">
      <shrinkable-menu :shrink="shrink" @on-change="handleSubmenuChange" :theme="menuTheme" :before-push="beforePush" :open-names="openedSubmenuArr" :menu-list="menuList">
        <div slot="top" class="logo-con">
          <a>
            <!-- <Icon type="cube" size="32"></Icon> -->
            <span class="project" v-show="!shrink">浦东人才服务</span>
            <!-- <h1>金陵科技</h1> -->
            <!-- <img class="logo-img" src="@/assets/images/logo.jpg" alt=""> -->
          </a>
        </div>
      </shrinkable-menu>
    </div>
    <div class="main-header-con" :style="{ paddingLeft: shrink ? '80px' : '256px' }">
      <div class="main-header">
        <div class="navicon-con">
          <Button type="text" @click="toggleClick" class="navicon-con-butn">
            <Icon type="md-list" size="26" />
          </Button>
        </div>
        <div class="header-middle-con">
          <div class="main-breadcrumb">
            <breadcrumb-nav :currentPath="currentPath"></breadcrumb-nav>
          </div>
        </div>
        <div class="header-avator-con">
          <full-screen v-model="isFullScreen" @on-change="fullscreenChange"></full-screen>
          <!-- <lock-screen></lock-screen> -->
          <!-- <notice></notice>   
                    <language-list></language-list> -->
          <div class="lock-screen-btn-con" style="position: relative;right: 60px;">
            <Button type="primary" @click="toPDRCLink()">返回浦东人才服务首页</Button>
          </div>
          <div class="user-dropdown-menu-con">
            <Row type="flex" justify="end" align="middle" class="user-dropdown-innercon">
              <Dropdown transfer trigger="click" @on-click="handleClickUserDropdown">
                <a href="javascript:void(0)">
                  <span class="main-user-name">{{ userName }}</span>
                  <Icon type="arrow-down-b"></Icon>
                </a>
                <DropdownMenu slot="list">
                  <DropdownItem name="changePassWord">{{L('修改密码')}}</DropdownItem>
                  <DropdownItem name="loginout">{{ L('注销') }}</DropdownItem>
                </DropdownMenu>
              </Dropdown>
              <span class="avatar" style="background: #619fe7; margin-left: 10px"><img src="../images/usericon.jpg" /></span>
            </Row>
          </div>
        </div>
      </div>
      <div class="tags-con">
        <tags-page-opened :pageTagsList="pageTagsList"></tags-page-opened>
      </div>
    </div>
    <div class="single-page-con" :style="{ left: shrink ? '80px' : '256px' }">
      <div class="single-page">
        <keep-alive :include="cachePage">
          <router-view></router-view>
        </keep-alive>
      </div>
      <!-- <copyfooter :copyright="L('金镂科技')"></copyfooter> -->
    </div>
    <!-- 修改密码弹框 -->
    <Modal v-model="pwdModelShow" :mask-closable="false" title="修改密码" width="500px">
      <div class="editForm" style="padding-right:20px">
        <Form ref="pwdForm" :model="pwdForm" label-position="right" :label-width="100" :rules="ruleInline">
          <Row>
            <Col span="24">
            <FormItem label="当前账号">
              <span>{{userName}}</span>
            </FormItem>
            </Col>
            <Col span="24">
            <FormItem prop="newPassword" label="新的密码">
              <Input type="password" placeholder="请输入新的密码" v-model.trim="pwdForm.newPassword">
              </Input>
            </FormItem>
            </Col>
          </Row>
        </Form>
      </div>
      <template #footer>
        <Button @click="closeModal('pwdForm')">取消</Button>
        <Button type="primary" @click="submitPwd('pwdForm')">保存</Button>
      </template>
    </Modal>
  </div>
</template>
<script >
import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import shrinkableMenu from '../components/shrinkable-menu/shrinkable-menu.vue'
import tagsPageOpened from '../components/tags-page-opened.vue'
import breadcrumbNav from '../components/breadcrumb-nav.vue'
import fullScreen from '../components/fullscreen.vue'
import lockScreen from '../components/lockscreen/lockscreen.vue'
import notice from '../components/notices/notice.vue'
import util from '../lib/util'
import copyfooter from '../components/Footer.vue'
import LanguageList from '../components/language-list.vue'
import AbpBase from '../lib/abpbase'
@Component({
  components: {
    shrinkableMenu,
    tagsPageOpened,
    breadcrumbNav,
    fullScreen,
    lockScreen,
    notice,
    copyfooter,
    LanguageList,
  },
})
export default class Main extends AbpBase {
  shrink = false
  get userName() {
    return this.$store.state.session.user ? this.$store.state.session.user.name : ''
  }
  pwdForm = { newPassword: '' }
  pwdModelShow = false
  isFullScreen = false
  messageCount = '0'
  ruleInline = {
    newPassword: [
      { required: true, message: '请输入新的密码', trigger: 'blur' },
      {
        // pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/,
        pattern: /^([a-zA-Z0-9@$!%*#?&]{8,16})$/,
        message: '密码为8-16个字符，必须包含大写、小写和数字！',
        trigger: 'blur',
      },
    ],
  }

  get openedSubmenuArr() {
    return this.$store.state.app.openedSubmenuArr
  }
  get menuList() {
    return this.$store.state.app.menuList
  }
  get pageTagsList() {
    return this.$store.state.app.pageOpenedList
  }
  get currentPath() {
    return this.$store.state.app.currentPath
  }
  get lang() {
    return this.$store.state.app.lang
  }
  get avatorPath() {
    return localStorage.avatorImgPath
  }
  get cachePage() {
    return this.$store.state.app.cachePage
  }
  get menuTheme() {
    return this.$store.state.app.menuTheme
  }
  get mesCount() {
    return this.$store.state.app.messageCount
  }
  init() {
    let pathArr = util.setCurrentPath(this, this.$route.name)
    this.$store.commit('app/updateMenulist')
    if (pathArr.length >= 2) {
      this.$store.commit('app/addOpenSubmenu', pathArr[1].name)
    }
    let messageCount = 3
    this.messageCount = messageCount.toString()
    this.checkTag(this.$route.name)
  }
  //修改密码提交
  submitPwd(name) {
    this.$refs[name].validate(async (valid) => {
      if (valid) {
        let { data } = await this.$Ajax.post(
          '/api/services/app/TsUserAdminService/ChangePasswordIndex',
          this.pwdForm
        )
        if (data.success) {
          // this.$Message.success({
          //   content: '修改成功',
          //   background: true,
          //   duration: 10, closable: true
          // })
          window.print(L('修改成功'))
          this.pwdModelShow = false
          this.$refs[name].resetFields()
          this.$store.commit('app/logout', this)
          util.abp.auth.clearToken()
          location.reload()
        } else {
          this.$Message.error({
            content: '修改失败,' + data.error.message,
            // background: true,
            duration: 10,
            closable: true,
          })
        }
      } else {
        this.$Message.error({
          content: '请完整填写表单',
          background: true,
          duration: 10,
          closable: true,
        })
      }
    })
  }
  toPDRCLink() {
    window.location.href = 'https://rc.pudong.gov.cn/jump'
  }
  closeModal(name) {
    this.$refs[name].resetFields()
    // ;(this.$refs[name] as Vue & { resetFields: () => boolean }).resetFields()
    this.pwdModelShow = false
  }
  toggleClick() {
    this.shrink = !this.shrink
  }
  handleClickUserDropdown(name) {
    if (name === 'changePassWord') {
      this.$refs['pwdForm'].resetFields()
      // ;(this.$refs['pwdForm'] as Vue & { resetFields: () => boolean }).resetFields()
      //   let { data } = await this.$Ajax.get(
      //     '/api/services/app/TsUserAdminService/GetUserAdminPassMgmtWordByAdminCode',
      //   )
      //   if (data.success) {
      this.pwdForm = {}
      //   }
      this.pwdModelShow = true
    } else if (name === 'loginout') {
      this.$store.commit('app/logout', this)
      window.history.replaceState(null, null, window.location.pathname)
      util.abp.auth.clearToken()
      localStorage.removeItem('isCheckFace')
      // location.reload()
      // window.location.href="https://rc.pudong.gov.cn/bshlogin"
      this.toPDRCLink()
    }
  }
  checkTag(name) {
    let openpageHasTag = this.pageTagsList.some((item) => {
      if (item.name === name) {
        return true
      } else {
        return false
      }
    })
    if (!openpageHasTag) {
      util.openNewPage(this, name, this.$route.params || {}, this.$route.query || {})
    }
  }
  handleSubmenuChange(val) {}
  beforePush(name) {
    if (name === 'accesstest_index') {
      return false
    } else {
      return true
    }
  }
  fullscreenChange(isFullScreen) {}
  @Watch('$route')
  routeChange(to) {
    this.$store.commit('app/setCurrentPageName', to.name)
    let pathArr = util.setCurrentPath(this, to.name)
    if (pathArr && pathArr.length > 2) {
      this.$store.commit('app/addOpenSubmenu', pathArr[1].name)
    }
    this.checkTag(to.name)
    localStorage.currentPageName = to.name
  }
  @Watch('lang')
  langChange() {
    util.setCurrentPath(this, this.$route.name)
  }
  mounted() {
    this.init()
  }
  created() {
    this.$store.commit('app/setOpenedList')
  }
}
</script>

